/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class CounterData
 */
import RestService from '@/modules/backend/RestService';
import { plainToClass } from 'class-transformer';
import { CounterData } from '@/modules/backend/Entities/CounterData';
import { FindCounterDataDto } from '@/modules/backend/CounterData/FindCounterDataDto';

export class CountersData {
  private readonly rest: RestService;

  constructor(rest: RestService) {
    this.rest = rest;
  }

  public async fetch(options: FindCounterDataDto): Promise<CounterData[]> {
    const data = await this.rest.get<CounterData[]>(`/api/v1/counter/${options.counterId}/data`, {
      params: options
    });

    return plainToClass(CounterData, data);
  }

  public async remove(dataId: number): Promise<void> {
    await this.rest.delete(`/api/v1/counter/data/${dataId}`);
  }
}
